/**
 * WordPress dependencies
 */
import { store, getContext } from '@wordpress/interactivity';

const { } = store('vertical', {
    actions: {
        prev() {
            const context = getContext();
            const gap = context.gap;
            const itemsTotal = context.itemsTotal;
            const itemsPerView = context.itemsPerView;
            context.currentIndex = (context.currentIndex - itemsPerView + itemsTotal) % itemsTotal;
            const offset = -context.currentIndex * (100 / itemsPerView);
            context.translateX = `calc(${offset}% - ${gap} * ${context.currentIndex})`;
        },
        next() {
            const context = getContext();
            const gap = context.gap;
            const itemsTotal = context.itemsTotal;
            const itemsPerView = context.itemsPerView;
            context.currentIndex = (context.currentIndex + itemsPerView) % itemsTotal;
            const offset = -context.currentIndex * (100 / itemsPerView);
            context.translateX = `calc(${offset}% - ${gap} * ${context.currentIndex})`;
        },
    }
});
